import React from 'react';
import ReactDOM from 'react-dom';
import GameManager from './components/GameManager';
import './index.css';

ReactDOM.render(
    <GameManager/>,
  document.getElementById('root')
);